const SkeletonCard = () => (
  <div className="rounded-lg border border-border bg-card p-5 space-y-4">
    <div className="h-40 rounded-md animate-shimmer" />
    <div className="flex gap-2">
      <div className="h-5 w-20 rounded animate-shimmer" />
      <div className="h-5 w-16 rounded animate-shimmer" />
    </div>
    <div className="h-5 w-3/4 rounded animate-shimmer" />
    <div className="h-4 w-full rounded animate-shimmer" />
    <div className="h-4 w-2/3 rounded animate-shimmer" />
  </div>
);

export default SkeletonCard;
